import React from "react";
import Classes from "./styles/style.module.css";
import Modal from "react-modal";
import { IoMdClose } from "react-icons/io";

const LigCustomModal = ({ open, closeHandler, dialogContent, scrollable }) => {
  return (
    <Modal
      isOpen={open}
      onRequestClose={closeHandler}
      style={
        scrollable
          ? {
              content: {
                backgroundColor: "#00022D",
                color: "var(--mainColor)",
                maxWidth: "400px",
                borderRadius: "1rem",
                height: "fit-content",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "1.3rem",
                zIndex: 9999,
                border: "none",
                animation: "fadeIn 0.6s ease-in-out",
              },
              overlay: {
                backgroundColor: "rgba(64, 86, 129, 68%)",
                zIndex: 9998,
                overflowY: "auto",
              },
            }
          : {
              content: {
                backgroundColor: "#00022D",
                color: "var(--mainColor)",
                maxWidth: "400px",
                borderRadius: "1rem",
                height: "fit-content",
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "1.3rem",
                zIndex: 9999,
                border: "none",
                animation: "fadeIn 0.6s ease-in-out",
              },
              overlay: {
                backgroundColor: "rgba(64, 86, 129, 68%)",
                zIndex: 9998,
              },
            }
      }
    >
      <div className={Classes.modalContainer}>
        <div className={Classes.closeIconContainer} onClick={closeHandler}>
          <IoMdClose />
        </div>
        {dialogContent && dialogContent}
      </div>
    </Modal>
  );
};

export default LigCustomModal;
